var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-form-item',{staticClass:"FormInput",attrs:{"label":_vm.field.label,"prop":_vm.field.prop,"label-width":_vm.labelWidth}},[_c('el-input',{style:({ width: _vm.field.width + 'px' }),attrs:{"value":_vm.value,"readonly":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }